import { StateParams } from "@uirouter/angularjs";
import { IOnInit, ICompileService } from "angular";
import { RecordDataSource } from "../../../records/grids";
import { ColDef } from "../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../records/server/query";
import { Record } from "../../../records/server/crud";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../app/records/server/serverUtility";

import 'angular-formly'
const gridId = Symbol("main.contract.process.view.grid");
export class ProcessViewController implements IOnInit {
  static $inject = [
    "$stateParams",
    serverUtilityName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    "$compile",
  ];
  readonly gridDataSource: RecordDataSource;
  readonly gridSettings: IGridSettings;
  readonly columns: ColDef[];
  readonly defaultQuery: IQuery = {};
  initialProcessIds = {};
  contractProcess!: any;
  processGroup!: any;
  contractId: string = "";

  constructor(
    public readonly $stateParams: StateParams,
    public readonly serverUtility: ServerUtility,
    gridSettingsService: GridSettingsService,
    columnDefinitionService: ColumnDefinitionService,
    $compile: ICompileService,
  ) {
    this.contractId = this.$stateParams["contractId"];
    this.gridDataSource = new RecordDataSource(
      serverUtility,
      "/api/processes/contracts/information?ContractId=" + this.contractId
    );
    this.gridSettings = gridSettingsService.getGridSettings(gridId);
    this.columns = [
      columnDefinitionService.getNumberColDef({
        field: "Id",
        header: "Id",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "ContractId",
        header: "Contract Id",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "Notes",
        header: "Notes",
      }),
      columnDefinitionService.getStringColDef({
        field: "Cbr",
        header: "Cbr",
      }),
      columnDefinitionService.getStringColDef({
        field: "PO",
        header: "PO",
      }),
      columnDefinitionService.getDateColDef({
        field: "ContractStartDate",
        header: "Start Date",
      }),
      columnDefinitionService.getStringColDef({
        field: "ContractEndDate",
        header: "End Date",
      }),
    ];
  }

  $onInit(): void {}
}
